var React = require('react');

function Checkbox (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"100","height":"100","rx":"16","key":0}),React.createElement("path",{"data-id":"inner-tick","d":"M21 51 l22 18 l35 -39","fill":"transparent","strokeWidth":"14","strokeLinecap":"round","strokeLinejoin":"round","className":"css-3tnpwi-CheckboxIcon","key":1})]);
}

Checkbox.defaultProps = {"viewBox":"0 0 100 100","focusable":"false","aria-hidden":"true"};

module.exports = Checkbox;

Checkbox.default = Checkbox;
